module.exports = "/images/vendor/flag-icon-css/flags/4x3/md.svg?5f734d921b0b2e2fa02cc33367a1d33e";